import { GivelifyLabel } from '@givelify/givelify-ui';
import { GivelifyNotification } from '@givelify/ui';
import { Grid, styled } from '@mui/material';

// export default makeStyles<Theme>((theme) => ({
//     ccbWrapper: {
//         gridColumnStart: 1,
//         gridColumnEnd: 3,
//         paddingBottom: theme.spacing(6),
//     },
// }));

export const DialogStyled = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1fr',
    width: '100%',
    margin: '0',
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
        padding: theme.spacing(5, 5, 0),
        gridTemplateColumns: '1fr 1fr',
        position: 'absolute',
        left: `calc(260px + ${theme.spacing(4)}px)`,
        width: '70%',
        maxWidth: '1000px',
    },
}));

export const DialogCloseStyled = styled('div')(({ theme }) => ({
    position: 'sticky',
    zIndex: 1,
    top: '0',
    right: '0',
    alignSelf: 'start',
    justifySelf: 'end',
    [theme.breakpoints.up('md')]: {
        gridArea: '1 / 2 / 2 / 3',
        position: 'absolute',
        top: `-${theme.spacing(4)}px`,
        right: `-${theme.spacing(4)}px`,
    },
}));

export const F1DialogStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 952,
    width: '100%',
    margin: '0',
    padding: theme.spacing(3),
    textAlign: 'center',
}));

export const F1CloseDialogStyled = styled('div')(({ theme }) => ({
    position: 'sticky',
    zIndex: 1,
    top: '0',
    right: '0',
    alignSelf: 'start',
    justifySelf: 'end',
    [theme.breakpoints.up('md')]: {
        gridArea: '1 / 2 / 2 / 3',
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
}));

export const F1TitleStyled = styled('div')(() => ({
    textAlign: 'center',
}));

export const F1ContentStyled = styled(GivelifyLabel)(({ theme }) => ({
    padding: theme.spacing(3, 6, 0),
    marginBottom: theme.spacing(4),
}));

export const F1ContinueStyled = styled('div')(({ theme }) => ({
    marginBottom: theme.spacing(3),
    display: 'flex',
    justifyContent: 'center',
}));

export const FindKeyStepStyled = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
}));

export const StepNumStyled = styled('span')(({ theme }) => ({
    width: 24,
    height: 24,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: theme.palette.primary.main,
    color: theme.palette.background.paper,
    borderRadius: '50%',
    marginRight: theme.spacing(4),
    fontSize: 16,
    fontWeight: 700,
}));

export const ConnectStyled = styled(GivelifyLabel)(() => ({
    width: '55%',
    margin: '0 auto 48px',
}));

export const LoginFormStyled = styled(Grid)(() => ({
    '& label': {
        zIndex: '10',
        '& + div': {
            margin: 0,
        },
    },
}));

export const FindKeyStyled = styled(Grid)(({ theme }) => ({
    textAlign: 'left',
    paddingLeft: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
    },
}));

export const FindKeyTitleStyled = styled(GivelifyLabel)(({ theme }) => ({
    marginBottom: theme.spacing(4),
}));

export const NotificationStyled = styled(GivelifyNotification)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}));
